import React, { useState, useEffect } from 'react';
import { PROJECTS } from '../data/projects';
import './Hero.css';

const HeroCarousel = () => {
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);
  const total = PROJECTS.length;

  useEffect(() => {
    if (paused) return;
    const t = setTimeout(() => setIdx(i => (i + 1) % total), 4500);
    return () => clearTimeout(t);
  }, [idx, paused, total]);

  const go = (n) => setIdx((n + total) % total);
  const cur = PROJECTS[idx];
  const prev = PROJECTS[(idx - 1 + total) % total];
  const next = PROJECTS[(idx + 1) % total];

  return (
    <div
      className="hero-carousel"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="hc-stage">
        {PROJECTS.map((p, i) => (
          <div
            key={p.id}
            className={`hc-slide${i === idx ? ' active' : ''}`}
            style={{ backgroundImage: `url(${p.mainImg})` }}
          />
        ))}
        <div className="hc-vignette" />
      </div>

      <div className="hc-content">
        <p className="hero-eyebrow">Costume Design</p>
        <h1 className="hero-title">Alina<br />Bokovikova</h1>
        <a href="#work" className="hero-cta">View Work</a>
      </div>

      <div className="hc-meta">
        <div className="hc-current">
          <div className="hc-current-title">{cur.title}</div>
          <div className="hc-current-sub">{cur.type} · {cur.venue} · {cur.year}</div>
        </div>
      </div>

      <div className="hc-controls">
        <button className="hc-btn" onClick={() => go(idx - 1)} aria-label="Previous">
          <span>←</span>
          <div className="hc-thumb" style={{ backgroundImage: `url(${prev.mainImg})` }} />
          <span className="hc-btn-label">{prev.title}</span>
        </button>
        <button className="hc-btn hc-btn-next" onClick={() => go(idx + 1)} aria-label="Next">
          <span className="hc-btn-label">{next.title}</span>
          <div className="hc-thumb" style={{ backgroundImage: `url(${next.mainImg})` }} />
          <span>→</span>
        </button>
      </div>

      <div className="hc-progress">
        {PROJECTS.map((_, i) => (
          <button
            key={i}
            className={`hc-dot${i === idx ? ' active' : ''}`}
            onClick={() => go(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroCarousel;